import React from "react";
import notifiaction from "../../images/notification.svg";
import user from "../../images/user.svg";
import UserImg from "../../images/default-user.svg";
import EnglishCanadaFlag from "../../images/canada.svg";
import { useState } from "react";
import * as modalActions from "../../redux/actions/modalActions";
import * as notification from "../../redux/actions/notificationAction";
import * as commonActions from "../../redux/actions/commonAction";
import * as profileActions from "../../redux/actions/profileAction";
import { bindActionCreators } from "redux";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { PREFERED_LANGUAGE_KEYS, ENGLISH, FRENCH, USER_ROLES } from "../../App.config";
import { setLanguage } from "redux-i18n";
import history from "../../utilities/history";
import * as utilities from "../../utilities/utils";
import useComponentVisible from "../../hooks/useComponentVisible";
import NotificationModal from "../../containers/Common/NotificationModal";
//Header Component

const Header = (props, context) => {
  const in18State = useSelector((state) => state.i18nState);
  const commonReducer = useSelector((state) => state.commonReducer);
  const notificationReducer = useSelector((state) => state.notification);
  const refOfLanguage = useComponentVisible(false);
  const refOfUserProfile = useComponentVisible(false);
  const [totalPendingApplication, seTotalPendingApplication] = useState(0);

  const dispatch = useDispatch();

  let initialState = {
    selectedLanguage: "",
  };

  const [state, setState] = useState(initialState);
  const commonAction = bindActionCreators(commonActions, dispatch);
  const profileAction = bindActionCreators(profileActions, dispatch);
  const notificationAction = bindActionCreators(notification, dispatch);

  // Change state for header language after i18State change
  useEffect(() => {
    setState(() => {
      return {
        ...state,
        selectedLanguage: in18State.lang,
      };
    });
  }, [in18State]);

  useEffect(() => {
    if (notificationReducer && notificationReducer.allPendingApplications.length > 0) {
      let lstPendingApplications = notificationReducer.allPendingApplications;
      if (!props.managersDetails.companyServices.hasSTDFormFeature)
        lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "STD")
      if (!props.managersDetails.companyServices.hasCCMFormFeature)
        lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "CCM")
      if (!props.managersDetails.companyServices.hasAIRFormFeature)
        lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "AIR")
      if (!props.managersDetails.companyServices.hasACMDFormFeature)
        lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "ACMD")

      seTotalPendingApplication(lstPendingApplications.length)
    }
  }, [notificationReducer])

  const onMenuItemClick = (path) => {
    history.push(path);
  };

  const onMenuToggle = () => {
    commonAction.setIsSideMenuOpen(!commonReducer.isSideMenuOpen);
  };

  const onLogout = () => {
    utilities.removeToken();
    profileAction.setManagerDetailsAction([]);
    history.push("/");
  };

  const onlanguagechange = (selectedLanguage) => {
    dispatch(setLanguage(selectedLanguage));
  };

  const onNotificationIconClick = (isShown) => {
    notificationAction.setNotificationShown(isShown);
  }

  return (
    <header className="m-Header">
      <div
        onClick={onMenuToggle}
        className="hamburger hamburger--squeeze js-hamburger"
      >
        <div className="hamburger-box">
          <div className="hamburger-inner"></div>
        </div>
      </div>

      <div className="Header-right">
        <div className="header-left">
          <h3>{props.managersDetails && (props.managersDetails.roleId != USER_ROLES.ADMIN && props.managersDetails.roleId != USER_ROLES.BROKER) ? props.managersDetails.companyName : ""}</h3>
        </div>
        <div className="right-header">
          <div
            className={
              refOfLanguage.isComponentVisible
                ? "dropdown Flag-dropdown open"
                : "dropdown Flag-dropdown"
            }
            onClick={() => {
              refOfLanguage.setIsComponentVisible(
                !refOfLanguage.isComponentVisible
              );
            }}
          >
            <button
              ref={refOfLanguage.ref}
              className="btn btn-secondary dropdown-toggle"
              type="button"
              id="dropdownMenu2"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {state.selectedLanguage == "en-US" ? (
                <div>
                  <img src={EnglishCanadaFlag} alt="" /> <span>{props.context.t("AIR-Employee-Information.form.label.text.EmployeePrefLang.Eng")}</span>
                </div>
              ) : (
                <div>
                  <img src={EnglishCanadaFlag} alt="" /> <span>{props.context.t("AIR-Employee-Information.form.label.text.EmployeePrefLang.Fr")}</span>
                </div>
              )}
            </button>

            <div className="dropdown-menu" aria-labelledby="dropdownMenu2">
              <button
                onClick={() => {
                  onlanguagechange(PREFERED_LANGUAGE_KEYS.EnglishUS);
                }}
                className="dropdown-item"
                type="button"
              >
                {props.context.t("AIR-Employee-Information.form.label.text.EmployeePrefLang.Eng")}
              </button>
              <button
                onClick={() => {
                  onlanguagechange(PREFERED_LANGUAGE_KEYS.FrenchCanada);
                }}
                className="dropdown-item"
                type="button"
              >
                {props.context.t("AIR-Employee-Information.form.label.text.EmployeePrefLang.Fr")}
              </button>
            </div>
          </div>
          {props.managersDetails && props.managersDetails.roleId != USER_ROLES.ADMIN && props.managersDetails.roleId != USER_ROLES.BROKER ?
            <button onClick={() => { onNotificationIconClick(true) }} type="button" className="btn btn-demo" data-toggle="modal" data-target="#myModal2">
              <a className="notifiaction head-icn">
                <img src={notifiaction} alt="" />
                <span>{totalPendingApplication}</span>
              </a>
            </button > : <div className="btn btn-demo"></div>}

          <NotificationModal
            notification={notificationReducer}
            onNotificationIconClick={onNotificationIconClick}
            managersDetails={props.managersDetails}
            context={props.context}
          />

          <div
            ref={refOfUserProfile.ref}
            className="dropdown"
            onClick={() =>
              refOfUserProfile.setIsComponentVisible(
                !refOfUserProfile.isComponentVisible
              )
            }
          >
            <a
              className="user-pro head-icn"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img
                src={
                  props?.managersDetails?.profileImageURL
                    ? utilities.BlobImageUrl(props?.managersDetails?.profileImageURL)
                    : UserImg
                }
                alt=""
              />
            </a>
            <div
              className={
                refOfUserProfile.isComponentVisible
                  ? "dropdown-menu show"
                  : "dropdown-menu"
              }
              aria-labelledby="dropdownMenuButton"
            >
              <a
                className="dropdown-item"
                onClick={() => {
                  onMenuItemClick("settings");
                }}
              >
                {props.context.t("Header.Account.text.MyAccount")}
              </a>
              <a
                className="dropdown-item"
                onClick={() => {
                  onLogout();
                }}
              >
                {props.context.t("Header.Account.text.Logout")}
              </a>
            </div>
          </div>
        </div>

      </div>
    </header>
  );
};

export default Header;
